import { FormEvent, useEffect, useMemo, useState } from 'react';
import { groupPropertiesByPrefix } from '../../utilities';
import { ItemListProps, ItemType } from './types';
import styles from './ItemList.module.scss';
import { useRect } from '@platform/ui-library';

const multilangPrefix = 'label.';

export function ItemList({ context, items, Items, ItemForm, onSave }: ItemListProps) {
  const [setRef, refRect, updateRect] = useRect();
  const [selectedId, setSelectedId] = useState<string | number | null>(null);
  const isOpenForm = selectedId != null;
  const selectedItem = useMemo(
    () => items.find(({ id }) => id === selectedId) || null,
    [items, selectedId]
  );

  const onItemClick = (id: string | number) => {
    setSelectedId(id);
  };

  const onSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const formData = new FormData(event.currentTarget);

    const formProps = Object.fromEntries(formData as any) as Record<string, string>;

    if (!formProps.intent) {
      return;
    }

    const shapedItem = groupPropertiesByPrefix({ ...formProps, id: selectedId }, multilangPrefix);
    const itemsToSave = getItemsToSave(shapedItem);
    saveChanges(itemsToSave);
  };

  const onRemoveItem = (id: string | number) => {
    saveChanges(getItemsToSave(id));
  };

  const saveChanges = (itemsToSave: ItemType[]) => {
    const cleanItemsToSave = itemsToSave.map(({ id: _, title: _0, ...props }) => {
      return props;
    });
    onSave(cleanItemsToSave);
    setSelectedId(null);
  };

  const getItemsToSave = (item: ItemType | string | number) => {
    // If the item is just an id, remove it
    const removeItem = typeof item === 'string' || typeof item === 'number';

    if (removeItem) {
      const filteredItems = items.filter(
        (currentItem) => currentItem.id !== item
      );
      return filteredItems;
    }

    let editItem = false;

    const updatedItems = items.map((currentItem) => {
      if (currentItem.id === item.id) {
        editItem = true;
        return item;
      }
      return currentItem;
    });

    if (!editItem) {
      return [...updatedItems, item];
    }
    return updatedItems;
  };

  useEffect(() => {
    updateRect();
  }, [selectedId]);

  const formProps = {
    context,
    selectedItem,
    onSubmit,
    onRemoveItem,
    onClose: () => setSelectedId(null),
    multilangPrefix,
    refRect
  };

  return (
    <>
      <div className="form-component-container buttonModal" ref={setRef}>
        <button
          className="form-button square"
          type="button"
          onClick={() => setSelectedId('new')}
        >
          +
        </button>
        <label>Reply Buttons</label>
      </div>

      <Items items={items} onClick={onItemClick} active={selectedId} styles={styles} />

      {isOpenForm && <ItemForm {...formProps} />}
    </>
  );
}




